import Vue from 'vue'
import Router from 'vue-router'
import { basicRoutes, menuRoutes } from './constants'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [...basicRoutes, ...menuRoutes]
})

export default router